var UpdateUserSignInTokenOutput = /** @class */ (function () {
    function UpdateUserSignInTokenOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserSignInTokenOutput.prototype.init = function (data) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    };
    UpdateUserSignInTokenOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    };
    UpdateUserSignInTokenOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    };
    UpdateUserSignInTokenOutput.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UpdateUserSignInTokenOutput();
        result.init(json);
        return result;
    };
    return UpdateUserSignInTokenOutput;
}());
export { UpdateUserSignInTokenOutput };
